<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <success *ngIf="success" class="mt-3">
    <p i18n="@@broker.priceAlertModal.successfullyActivated">Your alert has been activated successfully</p>
    <button class="btn btn-primary btn-block w-100" (click)="onFinish()"
      i18n="@@broker.priceAlertModal.closeButton">Close</button>
  </success>

  <div *ngIf="!success" class="content">
    <div class="tabs">
      <a
        href="javascript: void(0);"
        (click)="setMode(PriceAlertMode.ThresholdValue)"
        [class.active]="mode === PriceAlertMode.ThresholdValue" class="tab"
        i18n="@@broker.priceAlertModal.tabs.aboveOrBelow">Above/Below</a>
      <a
        href="javascript: void(0);"
        (click)="setMode(PriceAlertMode.Percentage)"
        [class.active]="mode === PriceAlertMode.Percentage" class="tab"
        i18n="@@broker.priceAlertModal.tabs.percentage">Percentage</a>
    </div>

    <div *ngIf="error" class="alert alert-warning">
      {{error}}
    </div>

    <div class="section row">
      <div class="field-wrap">
        <div class="key text-primary col-4" i18n="@@broker.priceAlertModal.price">Price</div>
        <div class="text-bold px-3">{{currency}} {{(price || 0) | number:'1.2-2'}}</div>
      </div>
    </div>

    <ng-container [ngSwitch]="mode">
      <ng-container *ngSwitchCase="PriceAlertMode.ThresholdValue">
        <div class="section row">
          <div class="field-wrap">
            <div class="key text-gray col-4" i18n="@@broker.priceAlertModal.below">Below</div>
            <div class="d-flex flex-column">
              <div class="field-element col-8 p-0">
                <label for="below">{{currency}}</label>
                <input class="input ps-2" type="number" formControlName="below" (keyup)="onThresholdChange()"
                  placeholder="Enter your price here" convertArabicNumbers>
              </div>
            </div>
          </div>
        </div>

        <div class="section row">
          <div class="field-wrap">
            <div class="key text-gray col-4" i18n="@@broker.priceAlertModal.above">Above</div>
            <div class="d-flex flex-column">
              <div class="field-element col-8 p-0">
                <label for="above">{{currency}}</label>
                <input class="input ps-2" type="number" formControlName="above" (keyup)="onThresholdChange()"
                  placeholder="Enter your price here" convertArabicNumbers>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="PriceAlertMode.Percentage">
        <div class="section text-center">
          <p class="text-gray m-0" i18n="@@broker.priceAlertModal.percentageDescription">Negative/Positive % Price Variation</p>
          <p class="text-bold">{{percentage}}%</p>
          <ngx-slider class="slider" [value]="percentage" [options]="percentageOptions"
            (valueChange)="onPercentageChange($event)"></ngx-slider>
        </div>
      </ng-container>
    </ng-container>

    <div class="section row">
      <div class="field-wrap align-items-center">
        <div class="key text-gray col-4" i18n="@@broker.priceAlertModal.notificationType">Notify By</div>
        <div class="val text-center col-8 justify-content-around">
          <div class="align-items-center d-flex">
            <mat-checkbox id="sms" (change)="toggleType('SMS')" [checked]="sms.value" i18n="@@broker.priceAlertModal.sms">SMS</mat-checkbox>
          </div>
          <div class="align-items-center d-flex">
            <mat-checkbox id="email" (change)="toggleType('EMAIL')" [checked]="email.value" i18n="@@broker.priceAlertModal.email">EMAIL</mat-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="p-2"></div>

    <div class="btns row">
      <div class="col-6">
        <button class="btn btn-primary btn-block" (click)="onSubmit()" [disabled]="form.invalid || loading">
          <ng-container *ngIf="loading" i18n="@@broker.priceAlertModal.submitLoading">Loading...</ng-container>
          <ng-container *ngIf="!loading" i18n="@@broker.priceAlertModal.activateButton">Activate</ng-container>
        </button>
      </div>
      <div class="col-6">
        <button class="btn btn-block btn-light" (click)="onCancel()"
          i18n="@@broker.priceAlertModal.cancelButton">Cancel</button>
      </div>
    </div>
  </div>
</form>
